/** Write payload for PATCH org `documenso_configuration`. The API token is per-user, never stored here. */
export type IDocumensoConfiguration = { is_documenso_enable: true; documenso_base_url: string } | Record<string, never>; // disable → {}

/** Documenso's hosted service; an admin can change it to a self-hosted Documenso. */
export const DOCUMENSO_CLOUD_URL = 'https://app.documenso.com';
